import axios from "../utils/http/axios";
import { ServerName } from "../utils/constants/serverName";
import { Broadcast, CreateBroadcastDTO, DismissResponse } from "../models/broadcast";
import { showNotification } from "../service/notification";
import { getI18n } from "../i18n";

export const getAllBroadcasts = async (): Promise<Broadcast[]> => {
  try {
    const response = await axios.get<Broadcast[]>(`${ServerName}/broadcast/all`);
    return Promise.resolve(response.data);
  } catch (e) {
    const t = getI18n().global.t;
    showNotification("error", t("broadcast.settings.load.error"));
    return Promise.reject(e);
  }
};

export const getActiveBroadcasts = async (): Promise<Broadcast[]> => {
  try {
    const response = await axios.get<Broadcast[]>(`${ServerName}/broadcast`);
    return Promise.resolve(response.data);
  } catch (e) {
    const t = getI18n().global.t;
    showNotification("error", t("broadcast.settings.load.error"));
    return Promise.reject(e);
  }
};

export const createBroadcast = async (data: CreateBroadcastDTO): Promise<Broadcast> => {
  try {
    const response = await axios.post<Broadcast>(`${ServerName}/broadcast`, data);
    return Promise.resolve(response.data);
  } catch (e) {
    const t = getI18n().global.t;
    showNotification("error", t("broadcast.settings.save.error"));
    return Promise.reject(e);
  }
};

export const updateBroadcast = async (data: Broadcast): Promise<Broadcast> => {
  try {
    const response = await axios.put<Broadcast>(`${ServerName}/broadcast`, data);
    return Promise.resolve(response.data);
  } catch (e) {
    const t = getI18n().global.t;
    showNotification("error", t("broadcast.settings.save.error"));
    return Promise.reject(e);
  }
};

export const deleteBroadcasts = async (ids: string[]): Promise<void> => {
  try {
    await axios.delete(`${ServerName}/broadcast`, { data: ids });
    return Promise.resolve();
  } catch (e) {
    const t = getI18n().global.t;
    showNotification("error", t("broadcast.settings.delete.error"));
    return Promise.reject(e);
  }
};

export const dismissBroadcast = async (id: string): Promise<DismissResponse> => {
  try {
    const response = await axios.put<DismissResponse>(`${ServerName}/broadcast/${id}/dismiss`);
    return Promise.resolve(response.data);
  } catch (e) {
    const t = getI18n().global.t;
    showNotification("error", t("broadcast.modal.dismiss.error"));
    return Promise.reject(e);
  }
};
